import React from 'react';
import { motion } from 'framer-motion';
import { XCircleIcon } from 'lucide-react';
export function ProblemSection() {
  const problems = ['Dejaste de invitar gente a comer por vergüenza', 'Vivís lavando sábanas a las 2 de la mañana', 'Tenés miedo de abrir la puerta de tu cuarto y encontrarte con una sorpresa en la almohada', 'Es agotador y destructivo para el vínculo con tu mascota'];
  return <section className="w-full bg-[#FAFAF7] py-16 md:py-20 px-6" data-id="element-77">
      <motion.div initial={{
      opacity: 0,
      y: 20
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.6
    }} className="max-w-3xl mx-auto" data-id="element-78">
        <h2 className="font-['Playfair_Display'] text-3xl md:text-4xl font-bold text-[#1C1C1C] mb-8 text-center" data-id="element-79">
          Vivir con olor a orina de gato te roba la libertad
        </h2>

        <p className="text-lg text-[#1C1C1C] leading-relaxed mb-8" data-id="element-80">
          Limpiaste con lavandina, probaste con vinagre, compraste las piedritas
          más caras del súper y hasta le gritaste cuando lo enganchaste "con las
          manos en la masa". Nada funcionó.
        </p>

        <div className="space-y-4" data-id="element-81">
          {problems.map((problem, index) => <motion.div key={index} initial={{
          opacity: 0,
          x: -20
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: index * 0.1
        }} className="flex items-start gap-3 bg-white p-4 rounded-lg" data-id="element-82">
              <XCircleIcon className="w-6 h-6 text-[#8B4513] flex-shrink-0 mt-1" data-id="element-83" />
              <p className="text-[#1C1C1C]" data-id="element-84">{problem}</p>
            </motion.div>)}
        </div>
      </motion.div>
    </section>;
}